<div *ngIf="!hideSticky; else sectionSelect" fxFlex="0 0 100%" fxLayout="row wrap" class="assignments-select">
    <app-sticky-header
        class="sticky-header"
        [title]="data.title"
        [context]="data.context"
        [contextIcon]="data.contextIcon"
        (onSubmit)="onSubmit()"
        (onCancel)="bottomSheetRef.dismiss(data)"
        [savingStatus]="saving"
    ></app-sticky-header>
    <div *ngIf="data.hint" class="sticky-info">
        <mat-icon>info</mat-icon>
        <span>{{ data.hint }}</span>
    </div>
    <div class="m-2" *ngIf="sheetData.scope != 'cluster'">
        <ng-container *ngTemplateOutlet="sectionSelect"></ng-container>
    </div>
    <div class="m-2" *ngIf="sheetData.scope === 'cluster'">
        <app-cluster-section-select
            [accessForm]="assignForm"
            [referenceFilter]="data.referenceFilter"
            [referencePropertyValue]="data.referencePropertyValue"
        ></app-cluster-section-select>
    </div>
</div>

<ng-template #sectionSelect>
    <app-section-select
        [hideTools]="true"
        [accessForm]="assignForm"
        [referenceFilter]="data.referenceFilter"
    ></app-section-select>
</ng-template>
